<div class="transfer__ownership-container">
  <div class="transfer__ownership-header">
    <div>
      <img src="../../../../../../assets/images/EmailWhiteBG.svg" width="98px" height="98px" />
      <h5 class="transfer__ownership-header-title">Tell us what you want</h5>
    </div>
    <div class="web__close-icon">
      <button  type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile">close</span>
      </button>
    </div>
  </div>
  <div class="transfer__ownership">
    <form [formGroup]="contactUsForm">
      <div class="transfer__ownership-message">
        <mat-form-field appearance="fill" class="form-design-ui">
          <!-- <input type="text" matInput formControlName="message" /> -->
          <textarea
            matInput
            #myTextarea
            autosize
            maxlength="1000"
            formControlName="message"
            placeholder="Tell us what type(s) of information we can help you manage..."
            data-gramm_editor="false"
            style="resize: none; font-size: 14px; line-height: 15px !important"
            >
          </textarea>
          @if (contactUsForm.controls['message'].errors) {
            <mat-error>Message is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="transfer__ownership-btn">
        <button (click)="sendInquiry()">Send</button>
      </div>
    </form>
  </div>
</div>
